import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment, useState } from 'react'

export const MobileModal: React.FC = () => {
    const [isOpen, setIsOpen] = useState<boolean>(true);

    const onClose = () => {
        setIsOpen(false)
    }

    return (
        <>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog
                    as="div"
                    className="fixed inset-0 z-10 overflow-y-auto bg-opacity-40 transition-all bg-black visible md:hidden"
                    onClose={onClose}
                >
                    <div className="min-h-screen px-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0" />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span
                            className="inline-block h-screen align-middle"
                            aria-hidden="true"
                        >
                            &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <div className="relative inline-block w-full max-w-sm my-8 overflow-hidden align-middle transition-all transform bg-offwhite shadow paragraph text-center">
                                <button
                                    type="button"
                                    className="inline-block absolute top-2 right-3 text-2xl"
                                    onClick={onClose}
                                >
                                    <i className="fal fa-times"></i>
                                </button>
                                <div className="pt-4 md:pt-6 px-4 md:px-6">
                                    <Dialog.Title
                                        as="h3"
                                        className="heading-3"
                                    >
                                        Mobile Version
                                    </Dialog.Title>
                                    <div className="mt-3 paragraph">
                                        <p className="mb-6">
                                        To get the most out of the site, accessing the desktop version is advised. It is a complex planning tool and you will likely use multiple tabs as you plan.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}